import {mapActions} from 'vuex'

import BuyerRegistryService from 'js/services/api/passenger_app/v1/ticketing/buyer-registry.js'

import template from './_buyer-registry-form.pug'

// @vue/component
export default Vue.extend({
  template: template(),
  props: {
    amount: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      data: {},
      errors: {}
    }
  },
  computed: {
    buyerRegistryId() {
      if (this.$user) {
        return this.$user.buyer_registry_id
      }
      return undefined
    },
    maxPaidAmount() {
      return this.administrativeArea.config.max_paid_amount
    },
    maxPaidAmountFormatted() {
      return this.$options.filters.moverickCurrency(this.maxPaidAmount)
    },
    canSkip() {
      return this.amount < this.maxPaidAmount
    },
    helper() {
      return this.$t(
        'recharge.buyerRegistryForm.helper',
        {maxPaidAmount: this.maxPaidAmountFormatted}
      )
    }
  },
  watch: {
    buyerRegistryId() {
      this.getBuyerRegistry()
    }
  },
  created() {
    this.getBuyerRegistry()
  },
  methods: {
    ...mapActions(['loadCurrentUser']),
    getBuyerRegistry() {
      if (this.buyerRegistryId) {
        BuyerRegistryService.show().then(data => {
          this.data = data
        })
      } else {
        this.cleanData()
      }
    },
    skipThisStep() {
      this.$emit('advance')
    },
    goToPreviousStep() {
      this.$emit('back')
    },
    goToNextStep() {
      if (this.$user) {
        this.updateBuyerRegistryAndContinue()
      } else {
        this.validateBuyerRegistryAndContinue()
      }
    },
    updateBuyerRegistryAndContinue() {
      BuyerRegistryService.update(this.data).then(() => {
        this.sendBuyerRegistryId()
      }).catch(data => {
        this.errors = data.data.errors
      })
    },
    validateBuyerRegistryAndContinue() {
      BuyerRegistryService.validate(this.data).then(() => {
        this.sendBuyerRegistryData()
      }).catch(data => {
        this.errors = data.data.errors
      })
    },
    async sendBuyerRegistryId() {
      await this.loadCurrentUser()
      this.$emit('advance', {buyer_registry_id: this.buyerRegistryId})
    },
    sendBuyerRegistryData() {
      this.$emit('advance', this.formattedData())
    },
    formattedData() {
      return this.addPrefixToKeys(this.data, 'buyer_')
    },
    addPrefixToKeys(object, prefix) {
      return Object.fromEntries(
        Object.entries(object).map(([k, v]) => [`${prefix}${k}`, v])
      )
    },
    cleanData() {
      this.data = {
        full_name: '',
        address: '',
        city: '',
        postal_code: '',
        nif: ''
      }
    }
  }
})
